import { saveCallbackStatus } from "@finpay-development/shared-components";
import { createSlice } from "@reduxjs/toolkit";

import { emptyLoadingState, LoadingState } from "../../models/loading-state";
import {
  emptyFacilityType,
  emptyImplementationFacility,
  FacilityType,
  ImplementationFacility,
} from "../../components/implementation-clients/details/models/implementation-facility";
import {
  blankFacilityDetails,
  FacilityDetails,
} from "../../models/facility-details";
import { blankFacilityForm, FacilityForm } from "../../models/facility-form";
import {
  getClientFacilities,
  getClientFacility,
  getClientFacilityById,
} from "./implementation-facility-thunk";

interface ImplementationSpecialistFacilityState {
  facility: FacilityType;
  facilities: ImplementationFacility[][];
  currentFacilityForm: Partial<FacilityForm>;
  currentFacilityDetails: FacilityDetails;
  apiResponsefacility: ImplementationFacility;
  uniqueAccountIds: string[];
  // common state for most/all slices
  apiStatus: saveCallbackStatus;
  errorMessage: string;
  isLoading: boolean;
  isLoadingKPIs: boolean;
  isGettingEncryptedFacId: boolean;
  paynowURL: string;
  finpassExternalAccountIds: string[];
  payNowExternalAccountIds: string[];
  isAddClientConnectAccountSuccessful: boolean;
  isAddPayNowClientConnectAccountSuccessful: boolean;
  isClientLoading: LoadingState;
}

const initialState: ImplementationSpecialistFacilityState = {
  facilities: [],
  facility: emptyFacilityType,
  currentFacilityForm: blankFacilityForm,
  currentFacilityDetails: blankFacilityDetails,
  apiResponsefacility: emptyImplementationFacility,
  uniqueAccountIds: [],
  apiStatus: saveCallbackStatus.none,
  errorMessage: "",
  isLoading: false,
  isLoadingKPIs: false,
  isGettingEncryptedFacId: false,
  paynowURL: "",
  finpassExternalAccountIds: [],
  payNowExternalAccountIds: [],
  isAddClientConnectAccountSuccessful: false,
  isClientLoading: emptyLoadingState,
  isAddPayNowClientConnectAccountSuccessful: false,
};

const specialistFacilitySlice = createSlice({
  name: "specialistFacilityContext",
  initialState,
  reducers: {
    clearStatus: (state) => {
      state.apiStatus = saveCallbackStatus.none;
      state.errorMessage = "";
    },
    resetSpecialistFacilityContext() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getClientFacilities.fulfilled, (state, action) => {
      state.facilities = action.payload.groupedFacilities;
      state.uniqueAccountIds = action.payload.uniqueAccountIds;
      state.isLoading = false;
    });
    builder.addCase(getClientFacilities.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getClientFacilities.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getClientFacility.fulfilled, (state, action) => {
      state.currentFacilityForm = action.payload?.facilityForm;
      state.currentFacilityDetails = action.payload?.facilityDetails;
      state.apiResponsefacility = action.payload?.apiResponseFacility;
    });
    builder.addCase(getClientFacility.pending, (state) => {});
    builder.addCase(getClientFacility.rejected, (state) => {
      state.apiStatus = saveCallbackStatus.error;
    });
    builder.addCase(getClientFacilityById.fulfilled, (state, action) => {
      state.facility = action.payload;
      state.isClientLoading.clientFacilityById = false;
    });
    builder.addCase(getClientFacilityById.pending, (state) => {
      state.isClientLoading.clientFacilityById = true;
    });
    builder.addCase(getClientFacilityById.rejected, (state) => {
      state.isClientLoading.clientFacilityById = false;
    });
  },
});

export const {
  clearStatus,
  resetSpecialistFacilityContext,
} = specialistFacilitySlice.actions;
export default specialistFacilitySlice.reducer;
